import React, { useState } from "react";
import {
    Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem,
    TableRow, Table,
    TableHead,
    TableBody,
    TableCell
} from "@material-ui/core";
import FeeMasterService from "./Locality/Service/feeMasterService";
import * as Yup from 'yup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import { Grid, Card, Box, Select, TextField } from "@material-ui/core";
import { useFormik } from 'formik';
import { useContext, useEffect } from 'react';
import { useTheme } from "@material-ui/styles";
import {
    ResponsiveContainer,
    ComposedChart,
    AreaChart,
    LineChart,
    Line,
    Area,
    PieChart,
    Pie,
    Cell,
    YAxis,
    XAxis,
} from "recharts";
import mock from "./mock";
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import { Typography } from "../../components/Wrappers/Wrappers";
import Dot from "../../components/Sidebar/components/Dot";
import BigStat from "./components/BigStat/BigStat";
import { withStyles, makeStyles } from '@material-ui/core/styles';
  const StyledTableCell = withStyles((theme) => ({
    head: {
      backgroundColor: "#0f3b62ad",
      color: theme.palette.common.white,
    },
    body: {
      fontSize: 14,
    },
  }))(TableCell);
const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
}));
export default function FeeMaster() {
    const tableHeaders = [ 'Acadamic Year',  'edit', 'delete'];
    const classes = useStyles();
    const [feeMasterList, setFeeMasterList] = useState([]);
    const [age, setAge] = React.useState('');
    var [error, setError] = useState(null);
    const [masterList, setMasterList] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [feeMaster, setFeeMaster] = useState({
        acadamicYear: ''
    });
    useEffect(() => {
        getFeeMasterList();
        return () => {
            setMasterList([]);
            setFeeMasterList([])
        }
    }, []);
    const handleOpen = (status) => {
      if(status){
        setFeeMaster({
          acadamicYear: ''
        })
      }
   
        setOpen(true);
    };
    const onclick = () => {

        setOpen(true);
      }
    const handleClose = () => {
        setOpen(false);
    };
    const handleChange = (event) => {
        setAge(event.target.value);
    };
    const getFeeMasterList = () => {
      const userDetails = JSON.parse(localStorage.getItem("userDetail"));
      
        FeeMasterService.getAllFeeMaster(userDetails.schooleId).then((res) => {
            setFeeMasterList(res);
        }).catch((err) => {
            // setError(err.message);
        });
    }
    const onSubmit = data => {
        console.log(JSON.stringify(data, null, 2));
      };
    const validationSchema = Yup.object().shape({
     
        acadamicYear: Yup.string().required(' required'),
    });
   
    const editSchooleId = (schooleid ) => {
        setFeeMaster(schooleid)
        handleOpen(false);
     
      }
      const deleteSchooleId = (schooleiddelete) => {
        if (schooleiddelete) {
          FeeMasterService.deleteFeeMaster(schooleiddelete).then((res) => {
            getFeeMasterList();
          }).catch((err) => {
          });
        }
      };
    const formik = useFormik({
        initialValues: feeMaster,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values, { resetForm }) => {
            if(feeMaster._id){

              
                FeeMasterService.upadeFeeMaster(values).then((res) => {
                    handleClose();
                    getFeeMasterList();
                    resetForm()
                    alert(" Updated Successfully.");
                    
                  }).catch((err) => {
                   
                  });
            }
            else {
                    FeeMasterService.creteFeeMaster(values).then((res) => {
                        getFeeMasterList();
                        handleClose();
                        resetForm();
                        alert("  Added Successfully.");
                    })
                
                .catch((err) => {
                    
                    alert(err.response.data.message)
                })
        }
    },
    });
    return (
        <>
            <PageTitle title="Fee Master" button={<Button

                variant="contained" onClick={() => handleOpen(true)}
                size="medium"
                color="secondary" style={{backgroundColor:'rgb(15 59 98)'}}> Add Fee Master
            </Button>} />
            <Grid container spacing={4}>
        <Grid item xs={12}>
          <Widget title="" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
            <Table className="mb-0">
              <TableHead >
                <TableRow>
                  {tableHeaders.map(key => (
                    <StyledTableCell key={key}>{key}</StyledTableCell>
                  ))}
                </TableRow>

              </TableHead>
              <TableBody>
                {feeMasterList.map((schooleId) => (
                  <TableRow key={schooleId._id}>
        
                    <TableCell className="pl-3 fw-normal" >{schooleId.acadamicYear}</TableCell>

                    <TableCell>
                      <EditIcon style={{ cursor: 'pointer' }} onClick={() => editSchooleId(schooleId)} >
                      </EditIcon >
                    </TableCell>
                    <TableCell>
                      <DeleteIcon style={{ cursor: 'pointer' }} onClick={() => deleteSchooleId(schooleId)} />
                    </TableCell>
               
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Widget>
        </Grid>
      </Grid>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Add Fee Master</DialogTitle>
                <form onSubmit={formik.handleSubmit} >
                    <DialogContent style= {{ width: 308 }}>
                        
                        <TextField
                            InputProps={{ style: { width: 258 } }}
                            autoFocus
                            margin="dense"
                            id="acadamicYear"
                            name="acadamicYear"
                            label="Acadamic Year"
                            type="text"
                            variant="standard"
                            value={formik.values.acadamicYear}
                            onChange={formik.handleChange}
                            error={formik.touched.acadamicYear && Boolean(formik.errors.acadamicYear)}
                            helperText={formik.touched.acadamicYear && formik.errors.acadamicYear}
                        />
                       
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Cancel</Button>
                        <Button type="submit" >Add</Button>
                    </DialogActions>
                </form>
            </Dialog>
        </>
    );
}


